import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  content: {
    display: 'flex',
    flex: '1',
    gap: spacing(4),
  },
  right: {
    flex: '1',
    flexDirection: 'column',
    display: 'flex',
    gap: spacing(2),
    height: '100%',
  },
  left: {
    width: '300px',
  },
  line: {
    display: 'flex',
    gap: spacing(2),
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: spacing(4),
  },
}));

export default useStyles;
